module.exports = __webpack_public_path__ + "static/img/09.9580edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/09.png
// module id = 5fX2
// module chunks = 1